import React from 'react';
import PropTypes from 'prop-types';
import { Manager, Popper, Reference } from 'react-popper';
import { Arrow, PoppersContainer, TooltipContainer } from './styles';
import { Heading, Paragraph } from '../../typography';

const modifiers = [
  {
    name: 'flip',
    enabled: false,
  },
  {
    name: 'preventOverflow',
    enabled: true,
  },
  {
    name: 'hide',
    enabled: false,
  },
];

const Tooltip = ({ title, text, children, position, textStyle, titleStyle }) => {
  const [over, setOver] = React.useState(false);

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <span
            ref={ref}
            style={{ display: 'inline-block' }}
            onMouseOver={() => {
              if (!over) setOver(true);
            }}
            onMouseLeave={() => {
              if (over) setOver(false);
            }}
            onFocus={() => {
              if (!over) setOver(true);
            }}
          >
            {children}
          </span>
        )}
      </Reference>
      {over && (
        <Popper placement={position || 'bottom'} modifiers={modifiers} eventsEnabled positionFixed>
          {({ ref, style, placement, arrowProps }) => {
            return (
              <PoppersContainer ref={ref} style={style} data-placement={placement}>
                <TooltipContainer>
                  {title && (
                    <Heading style={titleStyle} type={5} color="white" bold>
                      {title}
                    </Heading>
                  )}
                  <Paragraph
                    style={textStyle}
                    color="white"
                    small
                    noMargin
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </TooltipContainer>
                <Arrow ref={arrowProps.ref} data-placement={placement} style={arrowProps.style} />
              </PoppersContainer>
            );
          }}
        </Popper>
      )}
    </Manager>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
  position: PropTypes.string,
  textStyle: PropTypes.object,
  titleStyle: PropTypes.object,
};

export default Tooltip;
